import type { App } from "vue";
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";

export const constantRoutes: RouteRecordRaw[] = [
  /* SOP主播招募 */
  {
    path: "/activity/recruitment",
    name: "recruitment",
    component: () => import("@/views/activity/recruitment/index.vue"),
    meta: { title: "SOP主播招募" },
  }
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 全局注册 router
export function setupRouter(app: App<Element>) {
  app.use(router);
}

export default router;
